import React, {Component} from 'react';
import {
    KeyboardAvoidingView,
    Text,
    Animated,
    View,
    FlatList,
    ScrollView,
    TouchableOpacity,
    Image,
    Switch,
    Platform,
    BackHandler, Clipboard
} from "react-native"
import {useIsDrawerOpen} from '@react-navigation/drawer';

import Colors from "../../tools/Colors";
import {moderateScale} from "../../tools/Scaling";
import * as NavigationService from "../../redux/NavigationService";
import HMTextView from "../../customviews/HMTextView";
import HMItem from "../../customviews/HMItem";
import i18n from '../../I18n/i18n.js';
import {Tools} from "../../tools/Tools";
import DialogLoadingCustomize from "../../customviews/DialogLoadingCustomize";
//import DeviceInfo from "react-native-device-info";
import store from "../../redux/store";
import {typeExport} from "../../redux/store/type";
import PathFile from "../../assets/PathFile";
import {connect} from "react-redux";
import axios from "axios";
import HMAlert from "../../customviews/HMAlert";
import HMDialogWifiCheck from "../../customviews/HMDialogWifiCheck";

const width = typeExport.WIDTH;
const height = typeExport.HEIGHT;
let Main = null
let content = null

class MenuDrawerSatia extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: ["1", "2", "3"],
            switchValue: false,

            pending: false,
            success: false,
            error: '',

            backClickCount: 0,
            WifiCheck: false
        };
        content = this;
        this.springValue = new Animated.Value(100);


    }


    closeDrawer() {
        this.props.navigation.toggleRightDrawer()
    }

    componentWillMount() {
        BackHandler.addEventListener('hardwareBackPress', this.handleBackButton);
    }

    componentWillUnmount() {
        BackHandler.removeEventListener('hardwareBackPress', this.handleBackButton);

    }

    _spring() {
        this.setState({backClickCount: 1}, () => {
                // ParentScreen.ShowMessageBack(),
                //     setTimeout(function () {
                //         content.setState({backClickCount: 0});
                //     }, 1000)

            }
        )
        // this.setState({backClickCount: 1}, () => {
        //     ParentScreen.ShowMessageBack(),
        //         Animated.sequence([
        //             [
        //                 Animated.spring(
        //                     this.springValue,
        //                     {
        //                         toValue: -.15 * height,
        //                         friction: 5,
        //                         duration: 1000,
        //                         useNativeDriver: true,
        //                     }
        //                 ),
        //                 Animated.timing(
        //                     this.springValue,
        //                     {
        //                         toValue: 100,
        //                         duration: 1000,
        //                         useNativeDriver: true,
        //                     }
        //                 ),
        //
        //             ]
        //
        //         ]).start(() => {
        //             this.setState({backClickCount: 0});
        //         });
        // });

    }

    handleBackButton = () => {
        //  this.props.navigation.pop()
        // let routes = this.props.state.routes[0]
        // const state = navigationRef.current.getRootState();
        // const isDrawerOpen = state.history.some((it) => it.type === 'drawer');

        // if (this.props.route.isDrawerOpen) {
        //     this.props.navigation.closeDrawer()
        // } else {
        //     // if (routes.length > 1) {
        //     //     this.props.navigation.pop()
        //     // } else {
        //     //
        //     //     if (routes[0].routeName == "MainSatiaScreen") {
        //     //         if (Tools.CheckRoutes(this.props.route.routes[0].routes, 'LoginSatiaStack') !== undefined && this.props.route.routes[0].routes.length > 1) {
        //     //             this.props.navigation.pop()
        //     //
        //     //         } else
        //     //             this.state.backClickCount == 1 ? BackHandler.exitApp() : (this._spring())
        //     //
        //     //
        //     //     } else {
        //     //
        //     //         this.props.navigation.popToTop()
        //     //     }
        //     // }
        // }


        //  return true;

    };

    async componentDidMount() {

        /*   const dispatchConnected = isConnected => this.props.callserviceActionConnection(isConnected);

           NetInfo.isConnected.fetch().then().done(() => {
               NetInfo.isConnected.addEventListener('connectionChange', dispatchConnected);
           });*/

    }


    componentWillReceiveProps(props) {
    }


    setData() {
        let token = this.props.DataSplashScreen.token
        // this.props.callService(typeExport.urlMenuDrawerSatia, `?notify_status=${this.state.switchValue}&token=${token}`, typeExport.TypeSetMenuDrawerSatia, 'POST', token)
        // this.props.callService(urlGetAllData, `?lang=fa&token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC8xOTIuMTY4LjEuNDo4MDAwXC9hcGlcL2xvZ2luIiwiaWF0IjoxNTYxMzg4ODMwLCJleHAiOjE1NjEzOTI0MzAsIm5iZiI6MTU2MTM4ODgzMCwianRpIjoiSUlaWHZhdGVibjdFWXVzRCIsInN1YiI6MywicHJ2IjoiODdlMGFmMWVmOWZkMTU4MTJmZGVjOTcxNTNhMTRlMGIwNDc1NDZhYSJ9.o0KBrCIT25CGALibOQwiomiDzVVX7D9ensRGPsOCznY`, TypeGetAllData, 'POST', token)

    }

    toggleSwitch = (value) => {
        //onValueChange of the switch this function will be called
        this.setState({switchValue: value},
            () => {
                this.setData()

            }
        )

        //Tools.Request(typeExport.POST, "", '', '', '', this.setState({switchValue: value,success:true,result}), '')
        //state changes according to switch
        //which will result in re-render the text
    }

    render() {
        // let routes = this.props.route.routes[0].routes[0].routes;

        let user = this.props.DataSplashSatiaScreen.user;
        let {DataSplashSatiaScreen} = this.props;
        let customer = typeExport._NameApp == "SatiaOperator" ? user : user && user.customer;
        let checkImageUser = customer && (customer.Image || customer.image);

        return (
            <View style={{
                flex: 1,
                backgroundColor: Colors.white
            }}>
                <ScrollView>

                    <View
                        style={{
                            backgroundColor: Colors.white,
                            //height: moderateScale(70),
                            padding: moderateScale(8),

                            justifyContent: "center",
                            //    alignItems: "center"
                        }}>

                        <View style={{
                            backgroundColor: Colors.white,
                            //  padding: moderateScale(8),
                            flexDirection: 'row',
                            // //justifyContent: "flex-end",
                            alignItems: "flex-end",
                            //  justifyContent: "flex-end",
                            marginTop: Platform.OS === 'ios' ? typeExport.HeightStatusBar : 0
                        }}>
                            <View style={{
                                width: moderateScale(60),
                                height: moderateScale(60),
                                backgroundColor: '#ffffff',
                                borderRadius: moderateScale(30),
                                overflow: 'hidden',
                                alignItems: 'center', justifyContent: 'center',
                                borderWidth: moderateScale(1),
                                borderColor: Colors.light

                            }}>
                                <Image
                                    source={checkImageUser ? {uri: (customer.Image ? customer.Image : customer.image)} : PathFile.image.user}
                                    //resizeMode="stretch"
                                    style={[checkImageUser ? {} : {tintColor: Colors.colorPrimary,}, {
                                        width: moderateScale(58),
                                        height: moderateScale(58),
                                    }]}/>
                            </View>
                            <View
                                style={{width: moderateScale(10)}}/>
                            {
                                DataSplashSatiaScreen.token ?
                                    <View>
                                        <Image
                                            source={PathFile.image.logo}
                                            //resizeMode="stretch"
                                            style={[{}, {
                                                width: moderateScale(50),
                                                height: moderateScale(25),
                                            }]}/>
                                        <HMTextView
                                            text={customer ? (customer.FName ? customer.FName : customer.Name) + " " + (customer.LName ? customer.LName : "") : ''}
                                            style={{
                                                color: Colors.blackLight,
                                                fontSize: moderateScale(14),
                                                marginTop: moderateScale(4),
                                                //  backgroundColor:'#ee0042'
                                                //textAlign: 'center',
                                                //alignSelf: 'center'
                                            }}/>
                                        <HMTextView
                                            text={customer ? customer.Username : ''}
                                            style={{
                                                color: Colors.colorDarkText,
                                                fontSize: moderateScale(12),

                                                //  backgroundColor:'#ee0042'
                                                //textAlign: 'center',
                                                //alignSelf: 'center'
                                            }}/>
                                    </View>


                                    :
                                    <TouchableOpacity
                                        onPress={() => {
                                            //
                                            // store.dispatch(serviceActionSetState({type: "MainScreen"}))
                                            // NavigationService.navigateParams('LoginEnterPhoneScreen')
                                        }}
                                        style={{
                                            width: moderateScale(120),
                                            height: moderateScale(28),
                                            backgroundColor: Colors.white,
                                            borderRadius: moderateScale(6),
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                        <HMTextView
                                            type={'bold'}
                                            text={i18n.t('constant.Login')} style={{
                                            color: Colors.colorPrimary,
                                            fontSize: moderateScale(11),

                                        }}/>
                                    </TouchableOpacity>


                            }

                        </View>

                        <View style={{
                            backgroundColor: Colors.light,
                            height: moderateScale(1),
                            width: '95%',
                            alignSelf: 'center',
                            marginVertical: moderateScale(4)
                        }}/>
                    </View>

                    <View style={{flex: 1, marginTop: moderateScale(6)}}>

                        <HMItem icon={"home"} text={i18n.t('constant.Home')} navigateParams={() => {
                            this.props.navigation.toggleDrawer()

                            NavigationService.PopToPop();
                            //    NavigationService.navigatereset('MainSatiaScreen');

                        }}/>
                        {
                            typeExport._NameApp == "SatiaOperator" ?
                                null :
                                <HMItem
                                    typeIcon={"FontAwesome"}
                                    icon={"user"} text={i18n.t('constant.My_profile')} navigateParams={() => {
                                    NavigationService.navigateParams('ProfileSatiaScreen')

                                    // this.ChangeDrawer(routes, "ProfileSatiaScreen", null, 'login')


                                }}/>
                        }
                        {
                            typeExport._NameApp == "SatiaOperator" ?
                                null :
                                <HMItem
                                    icon={"globe"} text={i18n.t('constant.Website')} navigateParams={() => {
                                    //  NavigationService.navigateParams("google")
                                    Tools.GoLink(DataSplashSatiaScreen.results.info.portal)
                                    //  Tools.GoLink("https://sadad.shaparak.ir/VPG/Purchase?Token=0001A998466DAD3F15BBDEC3005B67B58E82E300ED2D8A190042")

                                }}/>
                        }
                        {
                            Platform.OS === "android" &&
                            <HMItem
                                icon={"ios-wallet-outline"}
                                //  typeIcon={"MaterialIcons"}
                                text={"متصل به هات اسپات"}
                                navigateParams={() => {
                                    NavigationService.navigateParams('HotSpotScreen')
                                    // this.setState({
                                    //     WifiCheck: true
                                    // })
                                }}/>
                        }
                        {
                            DataSplashSatiaScreen && DataSplashSatiaScreen.wallet && DataSplashSatiaScreen.wallet >= 0 && false &&
                            <HMItem
                                icon={"ios-wallet"}
                                typeIcon={"Ionicons"}
                                cammas
                                text={"افزایش حساب ( " + (DataSplashSatiaScreen.wallet / 10) + " تومان )"}
                                navigateParams={() => {
                                    NavigationService.navigateParams('IncreaseCreditSatiaScreen')
                                    //   NavigationService.navigateParams('ProfileSatiaScreen')

                                    // this.setState({
                                    //     WifiCheck: true
                                    // })
                                }}/>
                        }
                        {
                            typeExport._NameApp == "SatiaOperator" ?
                                null :
                                <HMItem
                                    icon={"power-plug"}
                                    typeIcon={"Entypo"}
                                    text={"درخواست تخلیه"} navigateParams={() => {
                                    HMAlert(
                                        i18n.t('constant.message'),
                                        "آیا از تخلیه مطمن هستید؟",
                                        [
                                            {
                                                text: i18n.t('constant.No'), onPress: () => {
                                                }, style: 'cancel'
                                            },
                                            {
                                                text: i18n.t('constant.ok'), onPress: () => {
                                                    this.setDischarge()

                                                }


                                            },

                                        ],
                                        {cancelable: true}
                                    )
                                }}/>
                        }


                        {/*      <HMItem
                            icon={"gift"}
                            typeIcon={"FontAwesome"}
                            text={"معرفی به دوستان"} navigateParams={() => {
                            NavigationService.navigateParams("IntroduceFriendsSatiaScreen")

                        }}/>*/}
                        {/*    <HMItem typeIcon={"FontAwesome"}
                                icon={"info-circle"} text={i18n.t('constant.About_software')} navigateParams={() => {
                            NavigationService.navigateParams('SatiaScreen')

                            //  this.ChangeDrawer(routes, "SatiaScreen")

                        }}/>*/}

                        {
                            typeExport._NameApp == "Ahvaz" ?

                                <HMItem icon={"wpforms"} text={i18n.t('constant.Poll')} navigateParams={() => {

                                    //  this.ChangeDrawer(routes, "PollScreen", null, 'login')
                                }}/>
                                : null
                        }

                        {
                            Platform.OS === "web" ?
                                null
                                :
                                <HMItem
                                    typeIcon={"Entypo"}

                                    icon={"network"} text={"تست شبکه"} navigateParams={() => {

                                    // this.ChangeDrawer(routes, "TestConnectionScreen")
                                }}/>
                        }


                    </View>

                </ScrollView>
                <View style={{width: '100%', alignItems: 'center', justifyContent: 'center'}}>
                    <TouchableOpacity
                        activeOpacity={1}
                        onPress={() => {
                            if (Platform.OS !== "web") {

                                if (Clipboard)
                                    Clipboard.setString(DataSplashSatiaScreen)
                            }
                        }}>
                        <HMTextView
                            // text={" ver " + DeviceInfo.getReadableVersion()}
                            //   text={i18n.t('constant.Version') + DeviceInfo.getVersion()}
                            text={i18n.t('constant.Version') + typeExport._Version}

                            style={{
                                color: Colors.blackLight,
                                fontSize: moderateScale(14),
                                textAlign: 'center',
                                alignSelf: 'center'
                            }}/>
                    </TouchableOpacity>


                </View>

                {
                    this.props.isLoadingSet || this.state.isLoading ?
                        <DialogLoadingCustomize/>
                        : null
                }

            </View>
        );
    }

    ChangeDrawer(routes, nameRouter, data, login) {
        if (Tools.CheckRoutes(routes, this.props.DataSplashSatiaScreen.token != null ? nameRouter : 'LoginEnterPhoneSatiaScreen') !== undefined) {
            this.closeDrawer()
            NavigationService.navigateParams(nameRouter)
        } else {
            // if (routes.length > 1)
            //     this.props.navigation.pop()
            // this.props.navigation.navigate(nameRouter, data);
            if (login) {
                if (this.props.DataSplashSatiaScreen.token != null) {
                    this.goScreen(nameRouter)
                    ///  NavigationService.navigatereset(nameRouter);
                } else {
                    store.dispatch(serviceActionSetState({type: nameRouter}))
                    // if (Tools.CheckRoutes(routes, 'LoginEnterPhoneScreen') !== undefined && routes.length <= 1) {
                    if (Tools.CheckRoutes(routes, 'LoginEnterPhoneSatiaScreen') !== undefined && routes.length <= 1) {
                        this.closeDrawer()

                    } else
                        NavigationService.navigateParams('LoginEnterPhoneSatiaScreen')
                }
            } else {
                //  NavigationService.navigatereset(nameRouter);
                this.goScreen(nameRouter)

            }

        }
    }

    goScreen(nameRouter) {
        //NavigationService.resetTo(nameRouter);
        //   NavigationService.navigatereset(nameRouter);
        NavigationService.navigateParams(nameRouter);

        /*try{
            NavigationService.navigatereset(nameRouter);
        }
        catch (e) {
            NavigationService.resetTo(nameRouter);
        }*/
    }

    setDischarge() {

        this.setState({
            //ShowImage:true
            isLoading: true,
            NoInternetDialog: false,

        })


        const formData = new FormData();
        formData.append('lang', i18n.locale);
        formData.append('token', this.props.token);
        formData.append('customer', this.props.DataSplashSatiaScreen.Account ? JSON.stringify(this.props.DataSplashSatiaScreen.Account) : null);


        const config = {
            headers: {
                "Content-Type": "multipart/form-data; charset=utf-8;",
                // 'Content-Type': 'application/json',
                // "Authorization": `Basic ${params.token}`,
                timeout: typeExport._TIMEOUT_FILE
            }
        };

        axios({
            method: 'post',
            url: typeExport._baseUrlSatia + "mail/discharge",
            data: formData,
            headers: {'Content-Type': 'multipart/form-data'},
            timeout: typeExport._TIMEOUT,

        })
        //   axios.post(typeExport._baseUrlSatia + "ibs/littlemore", formData, config)
            .then(async response => {
                let data = response.data;


                // data.status ? this.state.listImage.push(image) : null;
                HMAlert(
                    i18n.t('constant.message'),
                    data.message,
                    [
                        {
                            text: i18n.t('constant.ok'), onPress: () => {

                            }


                        },

                    ],
                    {cancelable: true}
                )
                if (data.status) {
                }
                else {

                }
                content.setState({
                    //ShowImage:true
                    //list: data.status ? list : this.state.list,
                    //TypeDocumentsList:[],
                    isLoading: false,
                    NoInternetDialog: !data.status,

                })
            }).catch((e) => {
            HMAlert(
                i18n.t('constant.message'),
                "خطا در ارتباط با سرور لطفا مجددا تلاش نمایید",
                [
                    {
                        text: i18n.t('constant.ok'), onPress: () => {

                        }


                    },

                ],
                {cancelable: true}
            )
            this.setState({
                //ShowImage:true
                isLoading: false,
                NoInternetDialog: true,

            })
            console.log('error', e)
        })
    }
}

const styless = {
    container: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center"
    },
    animatedView: {
        width,
        backgroundColor: "#0a5386",
        elevation: 2,
        position: "absolute",
        bottom: 0,
        padding: 10,
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "row",
    },
    exitTitleText: {
        textAlign: "center",
        color: "#ffffff",
        marginRight: 10,
    },
    exitText: {
        color: "#e5933a",
        paddingHorizontal: 10,
        paddingVertical: 3
    }
};

const mapStateToProps = state => {
    return {

        token: state.reducerSplashSatiaScreen.token,
        DataSplashSatiaScreen: state.reducerSplashSatiaScreen,

    };
};
const mapDispatchToProps = dispatch => {
    return {
        //  callServiceCommentScreen: (url, params, type, typeConnection, page, item_count, token) => dispatch(callWebserviceComment(url, params, type, typeConnection, page, item_count, token)),
        //   callServiceRtl: (data) => dispatch(serviceActionRtl(data)),

    }
};
export default connect(mapStateToProps, mapDispatchToProps)(MenuDrawerSatia);
